export class ComparisonReportClubProgramData {
  clubId: number;
  clubProgramID: number;
  programName: string;
  clubProgramTypeID: number;
  regStatus: number;
  programStatus: number;
  amountCollected: number;
  scholarshipDiscountAmount: number;
  amountOutStanding: number;
  currentParticipants: number;
  newParticipants: number;
  averageRevenue: number;

  constructor(data: any = {}) {
    Object.keys(data).forEach(key => this[key] = +data[key]);
    this.programName = data.programName;
  }
}

export class MonthlyPayment {
  paymentMonth: Date;
  paymentAmount: number;

  constructor(data: any = {}) {
    this.paymentAmount = +data.paymentAmount;
    this.paymentMonth = new Date(data.paymentMonth);
  }
}

export class ComparisonReportClubProgramDataWithPayment {
  clubProgramData: ComparisonReportClubProgramData;
  monthlyPaymentList: MonthlyPayment[];

  constructor(data: any = {}) {
    this.clubProgramData = new ComparisonReportClubProgramData(data.clubProgramData);
    this.monthlyPaymentList = (data.monthlyPaymentList || []).map(payment => new MonthlyPayment(payment));
  }
}

export class ComparisonReportSession {
  clubprogramID: number;
  clubprogramName: string;

  constructor(data: any = {}) {
    this.clubprogramID = +data.clubprogramID;
    this.clubprogramName = data.clubprogramName;
  }
}

export class ComparisonReport {
  currentProgramData: ComparisonReportClubProgramDataWithPayment;
  selectedProgramData: ComparisonReportClubProgramDataWithPayment;
  avrgRevenueDifference: number;
  memberDifference: number;
  newMemberDifference: number;
  paymentYearList: number[];
  scholarshipDiscountDifference: number;
  ttlRevenueDifference: number;

  constructor(data: any = {}) {
    Object.keys(data).forEach(key => this[key] = data[key]);
    this.currentProgramData = new ComparisonReportClubProgramDataWithPayment(data.currentProgramData);
    this.selectedProgramData = new ComparisonReportClubProgramDataWithPayment(data.selectedProgramData);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/comparison-report.ts